import BaseForm from "./formComponent/BaseForm";
import { useState, useEffect, useMemo } from "react";
import { apiPost } from "../utils/apiPost";
import Modal from "./Modal";
import PrivacyData from "../assets/privacy/cookie-privacy.json";
import { useProvinceOptions } from "../hooks/useProvinceOptions";


export default function Form({
  landingName,
  getFields,
  submitMapper,
  formSchema
}) {
  const { provinceOptions } = useProvinceOptions();
  const [isOpen, setIsOpen] = useState(false)
  const [idOrigin, setIdOrigin] = useState('');
  const [modalContent, setModalContent] = useState({
    title: '',
    content: ''
  });
  const consensoDatiText = PrivacyData.find((item) => item.id === 1);

  useEffect(() => {
    const cookies = document.cookie.split('; ');
    for (const cookie of cookies) {
      const [name, value] = cookie.split('=');
      if (name === 'IdOrigin') {
        setIdOrigin(value);
        break;
      }
    }
  }, []);

  const fields = useMemo(() => {
  if (!getFields) return [];

  if (typeof getFields === "function") {
    return getFields(provinceOptions);
  }

  return getFields;
}, [getFields, provinceOptions]);


  const onSubmit = async (data) => {
    const formData = submitMapper
      ? submitMapper({ data, landingName, idOrigin })
      : {
        NomeModulo: landingName,
        Provenienza: idOrigin,
        Dati: [],
      };

    try {
      const response = await apiPost({
        cat: "Leads",
        met: "SaveLead",
        np: 3,
        body: JSON.stringify(formData)
      });

      if (response.status === 200) {
        setModalContent({
          title: <span id="FormCompilato" className="text-green-600">Messaggio inviato con successo!</span>,
          content: ''
        });
      } else {
        setModalContent({
          title: <span id="ErroreForm" className="text-rose-700">Si è verificato un errore, Riprova!</span>,
          content: ''
        });
      }
    } catch (error) {
      console.log("Errore nell'invio del form:", error);
      setModalContent({
        title: <span id="ErroreForm" className="text-rose-700">Si è verificato un errore, Riprova!</span>,
        content: ''
      });
    }

    setIsOpen(true);
  };

  const handleOpenModal = () => {
     setModalContent({
    title: consensoDatiText?.title || "Informativa Privacy",
    content: (
      <div className="prose prose-invert max-w-none">
        <p>{consensoDatiText?.intro}</p>

        {consensoDatiText?.sections?.map((section, index) => (
          <section key={index} className="mt-6">
            <h3 className="font-bold">{section.heading}</h3>
            {section.paragraphs?.map((paragraph, pIndex) => (
              <p key={pIndex}>{paragraph}</p>
            ))}
          </section>
        ))}

        {consensoDatiText?.dataSubjectRights && (
          <section className="mt-6">
            <h3 className="font-bold uppercase">{consensoDatiText.dataSubjectRights.heading}</h3>
            <p>{consensoDatiText.dataSubjectRights.intro}</p>

            <ul className="list-disc pl-6 space-y-2">
              {consensoDatiText.dataSubjectRights.items.map((item, index) => (
                <li key={index}>
                  <strong>{item.title}.</strong> {item.description}
                </li>
              ))}
            </ul>
          </section>
        )}

        {consensoDatiText?.controller && (
          <section className="mt-6">
            <h3>{consensoDatiText.controller.heading}</h3>
            <p>
              {consensoDatiText.controller.companies.join(" / ")}, con sede operativa in{" "}
              {consensoDatiText.controller.operativeOffice}.
            </p>
            <p>
              È identificato un Responsabile della Protezione dei Dati all'indirizzo{" "}
              <a href={`mailto:${consensoDatiText.controller.dpoEmail}`}>
                {consensoDatiText.controller.dpoEmail}
              </a>.
            </p>
          </section>
        )}
      </div>
    )
  });

  setIsOpen(true);
  };

  return (
    <>
      <BaseForm
        fields={fields}
        onSubmit={onSubmit}
        schema={formSchema}
        openModal={handleOpenModal}
      />
      <Modal isOpen={isOpen} handleClose={() => setIsOpen(false)} title={modalContent.title}>
        {modalContent.content}
      </Modal>
    </>
  );
}